import { base } from "@base-provider";
import { API_PARAM } from "../constants/apiParams";

export const addDataset = async (urlData) => {
  return base.post({ url: API_PARAM.ADMIN_DATASETS, data: urlData, nonceHeader: true });
};

export const getUploadedDatasetStatus = async (id) => {
  return base.get({
    url: `${API_PARAM.ADMIN_DATASETS}/${id}`,
  });
};
